import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Activity, Bone, Heart, Stethoscope, Users, Award, ArrowRight,Tent } from 'lucide-react';
import arthroscopyImage from '../images/arthroscopy-knee-surgery-minimally-invasive-proce.jpg';
import sportsInjuryImage from '../images/sports-injury-treatment-athlete-rehabilitation-pr.jpg';
import jointCareImage from '../images/shoulder-knee-hip-joint-pain-treatment-orthopedic.jpg';
import fractureImage from '../images/fracture-trauma-care-orthopedic-emergency-treatmen.jpg';
import jointReplacementImage from '../images/joint-replacement-surgery-knee-hip-orthopedic-pro.jpg';
import physiotherapyImage from '../images/physiotherapy-rehabilitation-sports-medicine-recov.jpg';
import MedicalCamps from '../images/MedicalCamps.jpg';
import FootAnkel from '../images/Foot&Ankle.jpg';
import HandWrist from '../images/Hand&Wrist.jpg';
import SEO from './SEO';


export default function TreatmentsPage() {
  const treatmentsArticleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://www.drsujitkumar.com/treatments"
  },
  "headline": "Orthopedic Treatments in Hyderabad by Dr. Sujit Kumar",
  "description": "Comprehensive orthopedic treatments in Hyderabad including joint replacement, sports injury management, fracture care, arthroscopy, rehabilitation and more by Dr. Sujit Kumar.",
  "image": "https://www.drsujitkumar.com/images/treatments-overview.jpg",
  "author": {
    "@type": "Person",
    "name": "Dr. Sujit Kumar",
    "url": "https://www.drsujitkumar.com/treatments"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Dr. Sujit Kumar Orthopedic Clinic",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.drsujitkumar.com/images/logo.png"
    }
  },
  "datePublished": "2025-01-01",
  "dateModified": "2025-01-01"
};

  const treatments = [
    {
      icon: Activity,
      title: "Arthroscopy",
      description:
        "Minimally invasive procedures for Knee, Shoulder, Wrist joint including ACL, Meniscus, Rotator cuff repairs,Glenoid labral repairs , tfcc tears and Scapholunate tears",
      href: "/treatments/arthroscopy",
      image: arthroscopyImage,
    },
    {
      icon: Heart,
      title: "Sports Injuries",
      description:
        "Comprehensive management of athletic injuries from acute sprains to ligament tears, with structured return-to-play programs.",
      href: "/treatments/sports-injuries",
      image: sportsInjuryImage,
    },
    {
      icon: Users,
      title: "Shoulder & Knee ",
      description:
        "Specialized clinics for joint pain evaluation, conservative management, injections, and surgical interventions when needed.",
      href: "/treatments/shoulder-knee-hip",
      image: jointCareImage,
    },
    {
      icon: Bone,
      title: "Fractures & Trauma",
      description:
        "Emergency and planned fracture care including closed reductions, casting, surgical fixation, and comprehensive rehabilitation.",
      href: "/treatments/fractures-trauma",
      image: fractureImage,
    },
    {
      icon: Stethoscope,
      title: "Joint Replacement",
      description:
        "Total and partial replacement for Knee, Hip, Shoulder,Elbow and Hand ( 1st cmc and ip joints) with personalized recovery.",
      href: "/treatments/joint-replacement",
      image: jointReplacementImage,
    },
    {
      icon: Award,
      title: "Physiotherapy & Rehabilitation",
      description:
        "Post-injury and post-surgery rehabilitation programs with strength training, flexibility work, and sport-specific conditioning.",
      href: "/treatments/physiotherapy-rehab",
      image: physiotherapyImage,
    },
    {
      icon: Users,
      title: "Foot & Ankle",
      description:
        "Expert care for all foot and ankle injuries and conditions.",
      href:  "/treatments/foot-ankle",
      image: FootAnkel,
    },
    {
      icon:  Bone,
      title: "Hand & Wrist",
      description:
        "Specialized care for hand and wrist pain, injuries, and disorders.",
      href:"/treatments/hand-wrist",
      image: HandWrist,
    },
    {
      icon: Tent,
      title: "Medical Camps",
      description:
        "Community health camps offering free orthopaedic screening, bone health assessments, and sports injury prevention programs for underserved communities.",
      href: "/treatments/medical-camps",
      image: MedicalCamps,
    },
  ];

  return (
    <>
    <SEO
        title="Orthopedic Treatments in Hyderabad | Dr. Sujit Kumar"
        description="Explore comprehensive orthopedic treatments offered by Dr. Sujit Kumar in Hyderabad, including joint replacement, sports injuries, fractures, arthroscopy, physiotherapy & more."
        keywords="orthopedic treatments Hyderabad, Dr Sujit Kumar treatments, joint replacement Hyderabad, sports injury treatment, fracture care, arthroscopy, physiotherapy Hyderabad, orthopedic clinic Hyderabad"
        canonical="https://www.drsujitkumar.com/treatments"
        robots="index, follow"
        author="Dr. Sujit Kumar"
        publisher="Dr. Sujit Kumar Orthopedic Clinic"
        schema={treatmentsArticleSchema}
      />

    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-primary/90 text-primary-foreground py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-2xl">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4 font-playfair">
              Our Treatments
            </h1>
            <p className="text-lg text-primary-foreground/90 leading-relaxed">
              Comprehensive orthopaedic care across all aspects of bone, joint, and sports medicine with evidence-based
              treatments and personalized recovery plans.
            </p>
          </div>
        </div>
      </section>

      {/* Treatments Grid */}
      <section className="py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            {treatments.map((treatment) => (
              <Card key={treatment.title} className="overflow-hidden group hover:shadow-xl transition-shadow">
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={treatment.image}
                    alt={treatment.title}
                    className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <CardContent className="p-6">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-secondary/10 ">
                    <treatment.icon className="h-6 w-6" />
                  </div>
                  <h3 className="text-2xl font-semibold mb-3">{treatment.title}</h3>
                  <p className="text-muted-foreground mb-4 leading-relaxed">{treatment.description}</p>
                  <Button variant="outline" asChild>
                    <Link to={treatment.href}>
                      Learn More
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-muted/30">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4 font-playfair">
            Not Sure Which Treatment You Need?
          </h2>
          <p className="text-lg mb-8 text-muted-foreground max-w-2xl mx-auto">
            Book a consultation with Dr. Sujit Kumar to discuss your symptoms and get a personalized treatment plan.
          </p>
          <Button size="lg" asChild>
            <Link to="/book-appointment">
              Book Appointment
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </section>

      <Footer />
    </div>
    </>
  );
}